<template>
    <div data-cy="userInfoTabContent">
        <v-card class="tab-card">
            <v-container>
                <v-card-title>{{ $t('passAccount.header.userInfoTitle') }}</v-card-title>
                <v-card-text>
                    <div v-if="isLoadingUserInfo">
                        <v-skeleton-loader
                            v-for="n in 6"
                            :key="`user-info-skeleton-${n}`"
                            class="mb-2"
                            type="text"
                        ></v-skeleton-loader>
                    </div>
                    <div v-else-if="userInfo">
                        <p>
                            {{ $t('passAccount.userInfo.geodisLogin') }}:
                            <b>{{ userInfo.geodisLogin }}</b>
                        </p>
                        <p>
                            {{ $t('passAccount.userInfo.firstname') }}:
                            <b>{{ userInfo.firstname }}</b>
                        </p>
                        <p>
                            {{ $t('passAccount.userInfo.lastname') }}:
                            <b>{{ userInfo.lastname }}</b>
                        </p>
                        <p>
                            {{ $t('passAccount.userInfo.mail') }}:
                            <b>{{ userInfo.mail }}</b>
                        </p>
                        <p>
                            {{ $t('passAccount.userInfo.proNumber') }}:
                            <b>{{ userInfo.proNumber }}</b>
                        </p>
                        <p>
                            {{ $t('passAccount.userInfo.proMobile') }}:
                            <b>{{ userInfo.proMobile }}</b>
                        </p>
                    </div>
                </v-card-text>
                <v-spacer></v-spacer>

                <v-card-title>{{ $t('passAccount.header.userServicesTitle') }}</v-card-title>
                <v-card-text>
                    <div v-if="isLoadingUserAccessList">
                        <v-skeleton-loader class="mb-4" type="table"></v-skeleton-loader>
                    </div>
                    <div v-else-if="userInformations">
                        <v-card-text>
                            <v-text-field
                                v-model="searchAccess"
                                :label="$t('passAccount.serviceAccess.search')"
                                prepend-inner-icon="mdi-magnify"
                                clearable
                                hide-details
                                class="mb-3"
                            ></v-text-field>
                        </v-card-text>

                        <v-row>
                            <v-col>
                                <v-data-table
                                    :headers="serviceListHeader"
                                    :items="serviceList"
                                    :search="searchAccess"
                                    item-key="id"
                                    :group-by="['serviceName']"
                                    :items-per-page="-1"
                                    hide-default-footer
                                >
                                    <template v-slot:[`group.header`]="{ group, items, isOpen, toggle }">
                                        <td :colspan="serviceListHeader.length" class="text-start">
                                            <v-btn @click="toggle" small text>
                                                <v-icon>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </v-btn>
                                            <a
                                                v-if="items[0].APPLICATIONURL"
                                                class="serviceUrl"
                                                target="_blank"
                                                :href="$sanitize(items[0].APPLICATIONURL)"
                                            >
                                                <strong>{{ group }}</strong>
                                            </a>
                                            <strong v-else>{{ group }}</strong>
                                            <span class="ml-2 text--secondary">({{ items.length }})</span>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-spacer></v-spacer>
            </v-container>
        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchAccess: ''
        };
    },
    computed: {
        userInformations() {
            return this.$store.getters.getUserInformations;
        },
        userInfo() {
            return this.userInformations?.userInfo;
        },
        isLoadingUserInfo() {
            return this.$store.getters.getLoadingUserInfo;
        },
        isLoadingUserAccessList() {
            return this.$store.getters.getLoadingUserAccessList;
        },
        serviceListHeader() {
            return [
                {
                    text: this.$t('passAccount.serviceAccess.serviceName'),
                    value: 'serviceName',
                    sortable: true,
                    groupable: true
                },
                {
                    text: this.$t('passAccount.serviceAccess.accessLabel'),
                    value: 'accessLabel',
                    sortable: false,
                    groupable: false
                },
                {
                    text: this.$t('passAccount.serviceAccess.directoryType'),
                    value: 'directory',
                    sortable: false,
                    groupable: false
                }
            ];
        },
        serviceList() {
            if (!this.userInformations?.userAccessList) return [];
            let idCounter = 0;
            return this.userInformations.userAccessList
                .map(item =>
                    item.accesses.map(a => ({
                        id: idCounter++,
                        APPLICATIONURL: item.APPLICATIONURL,
                        serviceName: item[`SERVICENAME${this.$i18n.locale.toUpperCase()}`],
                        accessLabel: a[this.$i18n.locale],
                        directory: a.directory || 'LDAP'
                    }))
                )
                .flat();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}

.tab-card {
    margin: 20px 0px 0px 20px;
    .header {
        .actions {
            .v-btn {
                margin-left: 20px;
            }
        }
    }
    h3 {
        padding: 15px;
    }
}

.serviceUrl {
    text-decoration: none;
    color: #1976d2;
    font-weight: bold;
}

.serviceUrl:hover {
    text-decoration: underline;
}
</style>
